import { Component, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-seleccionar-linea',
  templateUrl: './seleccionar-linea.component.html',
  styleUrls: ['./seleccionar-linea.component.css']
})
export class SeleccionarLineaComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  data:any;
  @ViewChild(MatAccordion) accordion: MatAccordion;
  ngOnInit(): void {
  

  }

  select(item) {
    this.activeModal.close(item);
  }

  cerrar() {
    this.activeModal.close();
  }

}
